!(function ($) {
  var body = $("body"),
    wishListsArr = localStorage.getItem("wishListsArr")
      ? JSON.parse(localStorage.getItem("wishListsArr"))
      : [];
  (localStorage.setItem("wishListsArr", JSON.stringify(wishListsArr)),
    wishListsArr.length &&
      (wishListsArr = JSON.parse(localStorage.getItem("wishListsArr"))),
    $(document).ready(function () {
      ($(document).ajaxStart(function () {
        nuranium.isAjaxLoading = !0;
      }),
        $(document).ajaxStop(function () {
          nuranium.isAjaxLoading = !1;
        }),
        nuranium.init(),
        $("#popup-subscribe i.zmdi-close").on("click", function () {
          $(this).parents("#popup-subscribe").modal("hide");
        }));
      var t = {
        shop: vinovathemes.main_info.shop,
        purchase_code: vinovathemes.main_info.lic,
        shopify_domain: vinovathemes.main_info.domain,
        status: vinovathemes.main_info.status,
      };
      nuranium.validLicense(t);
    }));
  var nuranium = {
    validLicense: function (t) {
      $.ajax({
        url: "https://vinovathemes.com/license/check_license.php",
        type: "post",
        data: t,
        success: function (t) {
          var a = JSON.parse(t);
          if (
            ($("#Nov_purchasecode").on("contextmenu", function (t) {
              t.preventDefault();
            }),
            !1 == a.status)
          )
            return (
              $("#Nov_purchasecode").removeClass("hide hidden"),
              $("#Nov_purchasecode-waring").html(a.msg),
              !1
            );
          a.status &&
            ($("#Nov_purchasecode-waring").html(a.msg).slideDown(250),
            setTimeout(function () {
              $("#Nov_purchasecode").remove();
            }, 1e3));
        },
      });
    },
    isAjaxLoading: !1,
    init: function () {
      (this.closeModal(),
        this.novProductTabs(),
        this.initNovWishListIcons(),
        this.doAddOrRemoveWishlistProduct(),
        this.doAddOrRemoveWishlist(),
        $("body").hasClass("template-page") &&
          $(".wishlist-page").length &&
          this.initNovWishListsPage(),
        this.ajaxProductAddToCart(),
        this.ajaxChangeFromCart(),
        this.initMiniCart(),
        this.ajaxRemoveFromCart(),
        this.changeQuantityPageCart(),
        this.initCollapseSidebarBlock(),
        this.changeQuantityMiniCart(),
        this.initproductItemColorSwatch(),
        this.productItemSwatch(),
        this.togglePopupAddToCart(),
        body.hasClass("template-collection") &&
          this.initCollectionPageLoadmore(),
        $(window).width() > 767 && this.initQuickView());
    },
    initCollectionPageLoadmore: function () {
      var t = $(".scroll__infitiny"),
        a = ".scroll__infitiny a";
      t.length &&
        (body
          .off("click.initCollectionPageLoadmore", a)
          .on("click.initCollectionPageLoadmore", a, function (t) {
            if (
              (t.preventDefault(),
              t.stopPropagation(),
              !$(this).hasClass("disabled"))
            ) {
              var a = $(this).data("href");
              nuranium.ajaxCollectionPageLoadmoreGetContent(a);
            }
          }),
        $(window).scroll(function () {
          if (!nuranium.isAjaxLoading) {
            var t,
              i,
              e = $(".collection-filter__content"),
              o = e.offset().top + e.outerHeight() - $(window).height();
            if ($(this).scrollTop() > o && $(this).scrollTop() < o + 200) {
              var n = $(a);
              if (n.length && !n.hasClass("disabled")) {
                var s = n.data("href");
                nuranium.ajaxCollectionPageLoadmoreGetContent(s);
              }
            }
          }
        }));
    },
    ajaxCollectionPageLoadmoreGetContent: function (t) {
      nuranium.isAjaxLoading ||
        $.ajax({
          type: "GET",
          url: t,
          beforeSend: function () {
            $(".scroll__infitiny").removeClass("loading").addClass("loading");
          },
          success: function (t) {
            nuranium.ajaxCollectionPageLoadmoreMapData(t);
          },
          complete: function () {
            $(".scroll__infitiny").removeClass("loading");
          },
        });
    },
    ajaxCollectionPageLoadmoreMapData: function (t) {
      var a = $(".collection-template"),
        i = a.find(".product-collection"),
        e = a.find(".paging"),
        o = $(t).find(".collection-template");
      if (
        ((newProductCollection = o.find(".product-collection")),
        (newProductCount = o.find(".paging")),
        (newProductItem = newProductCollection.children(".product--item")),
        e.replaceWith(newProductCount),
        newProductCollection.length)
      ) {
        i.append(newProductItem);
        var n = a.find(".product--item").length,
          s = $(".pagination__bar").data("max");
        ($(".pagination__count .count").text(n),
          $(".pagination__bar .progress").css("width", (n / s) * 100 + "%"));
      }
    },
    togglePopupAddToCart: function () {
      ($(".selector-wrapper-1").each(function () {
        $(this).hasClass("opt-color.hide") &&
          $(this)
            .closest(".item-product__popup--variant")
            .find(".btn-close-quick-add")
            .hide();
      }),
        $(document).on("click", ".btn-quick-add", function () {
          ($(".item-product__popup--variant").removeClass("act"),
            $(".item-product .thumbnail-container").removeClass("popup-act"),
            $(this)
              .parents(".item-product")
              .find(".item-product__popup--variant")
              .addClass("act"),
            $(this).parents(".item-product").addClass("act"),
            $(this).parents(".shopify-section").addClass("act"),
            $(this)
              .parents(".item-product")
              .find(".product__bottom")
              .addClass("act"),
            $(this).parents(".thumbnail-container").addClass("popup-act"),
            !0 == $(this).parents(".nov-slick-carousel").data("nav") &&
              $(this)
                .parents(".nov-slick-carousel")
                .find(".slick-arrow")
                .css("visibility", "hidden"),
            !0 == $(this).parents(".collection-carousel").data("nav") &&
              $(this)
                .parents(".collection-carousel")
                .find(".slick-arrow")
                .css("visibility", "hidden"));
        }),
        $(document).on("click", ".btn-close-quick-add", function () {
          ($(this).parent().removeClass("act"),
            $(this).parents(".thumbnail-container").removeClass("popup-act"),
            $(this)
              .parents(".item-product")
              .find(".item-product__popup--variant")
              .removeClass("act"),
            $(this).parents(".item-product").removeClass("act"),
            $(this).parents(".shopify-section").removeClass("act"),
            $(this)
              .parents(".item-product")
              .find(".product__bottom")
              .removeClass("act"),
            !0 == $(this).parents(".nov-slick-carousel").data("nav") &&
              $(this)
                .parents(".nov-slick-carousel")
                .find(".slick-arrow")
                .css("visibility", "visible"),
            !0 == $(this).parents(".collection-carousel").data("nav") &&
              $(this)
                .parents(".collection-carousel")
                .find(".slick-arrow")
                .css("visibility", "visible"));
        }));
    },
    initCollapseSidebarBlock: function () {
      $(document).on("click", ".facets__label--title", (t) => {
        var a = $(t.currentTarget),
          i = a.parents(".js-filter").find(".facets__content");
        a.parent().hasClass("act")
          ? (a.parent().removeClass("act"),
            a.parents(".js-filter").removeClass("act"),
            i.slideUp())
          : (a.parent().addClass("act"),
            a.parents(".js-filter").addClass("act"),
            i.slideDown());
      });
    },
    closeModal: function () {
      $(".close-modal, .overlay").click(function () {
        $(".loading-modal").css({
          opacity: "0",
          visibility: "hidden",
          transform: "translateX(410px)",
          transition: "all 0.3s",
        });
      });
    },
    novProductTabs: function () {
      $("[data-product-tabs]").each(function () {
        var t = $(this),
          a = t.find(".list-product-tabs").find("[data-product-tabtop]"),
          i = t.find("[data-product-TabContent]"),
          e = t.find(".list-product-tabs .tab-links.active"),
          o = t.find(".tab-content.active");
        (nuranium.doAjaxNovProductTabs(
          e.data("href"),
          o.find(".products-grid"),
          a,
        ),
          a.off("click").on("click", function (t) {
            if (
              (t.preventDefault(),
              t.stopPropagation(),
              !$(this).hasClass("active") && !$(this).hasClass("active"))
            ) {
              var e = $(this),
                o = $(e.data("target"));
              (a.removeClass("active"),
                i.removeClass("active"),
                o.find(".collection-carousel").hasClass("slick-initialized") ||
                  nuranium.doAjaxNovProductTabs(
                    e.data("href"),
                    o.find(".products-grid"),
                    a,
                  ),
                e.addClass("active"),
                o.addClass("active"));
            }
          }));
      });
    },
    doAjaxNovProductTabs: function (t, a, i) {
      $.ajax({
        type: "GET",
        url: window.router + t,
        beforeSend: function () {
          i.css({ "pointer-events": "none", opacity: "0.6" });
        },
        success: function (e) {
          if (
            "/collections/?view=json" == t ||
            "/collections/?view=new-json" == t
          );
          else {
            a.html($(e).find(".grid-item").html());
            var o = i.data("limit") - 1;
            (a.find(".block:gt(" + o + ")").remove(),
              a.hasClass("collection-carousel") &&
                !a.hasClass("slick-initialized") &&
                nuranium.initNovProductTabsSlider(a.parent()),
              nuranium.initNovWishListIcons());
          }
        },
        complete: function () {
          (i.css({ "pointer-events": "auto", opacity: "1" }),
            (function () {
              let t = document.createElement("script");
              ((t.type = "text/javascript"),
                (t.async = !0),
                (t.src = `https://cdn.shopify.com/extensions/505ce933-6eff-47ee-a32f-dee5ae134593/0.0.0/assets/air-reviews-main.min.js?v=${new Date().getTime()}`));
              let a = document.getElementsByTagName("script")[0];
              a.parentNode.insertBefore(t, a);
            })());
        },
      });
    },
    initNovProductTabsSlider: function (t) {
      t.each(function () {
        var t = $(this).find(".products-grid"),
          a = !!$("html").hasClass("lang-rtl"),
          i = t.data("nav");
        (!0 == t.data("custnav") && (i = !1),
          t.not(".slick-initialized") &&
            (t.on("init", function (a) {
              var i = !1;
              (t.on("mousedown touchstart", function (t) {
                i = !0;
              }),
                t.on("mousemove touchmove", function (a) {
                  i &&
                    (t
                      .find(".slick-slide.slick-active:first")
                      .prev()
                      .addClass("slick-act"),
                    t
                      .find(".slick-slide.slick-active:last")
                      .next()
                      .addClass("slick-act"));
                }),
                t.on("mouseup touchend", function () {
                  ((i = !1), t.find(".slick-slide").removeClass("slick-act"));
                }));
            }),
            t.slick({
              nextArrow:
                '<div class="arrow-next"><i class="rbb-icon-direction-39"></i></div>',
              prevArrow:
                '<div class="arrow-prev"><i class="rbb-icon-direction-36"></i></div>',
              rtl: a,
              slidesToShow: t.data("items_xxl"),
              slidesToScroll: t.data("items_xxl"),
              rows: t.data("row"),
              row_mobile: t.data("row_mobile"),
              arrows: i,
              dots: t.data("dots"),
              infinite: t.data("loop"),
              adaptiveHeight: !0,
              responsive: [
                {
                  breakpoint: 1441,
                  settings: {
                    slidesToShow: t.data("items"),
                    slidesToScroll: t.data("items"),
                  },
                },
                {
                  breakpoint: 1200,
                  settings: {
                    slidesToShow: t.data("items_lg"),
                    slidesToScroll: t.data("items_lg"),
                  },
                },
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: t.data("items_md"),
                    slidesToScroll: t.data("items_md"),
                  },
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: t.data("items_sm"),
                    slidesToScroll: t.data("items_sm"),
                    arrows: !1,
                  },
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: t.data("items_xs"),
                    slidesToScroll: t.data("items_xs"),
                    arrows: !1,
                    rows: t.data("row_mobile"),
                  },
                },
              ],
            }),
            $("[data-product-tabs]")
              .find(".nav-prev")
              .click(function () {
                $(this)
                  .parents("[data-product-tabs]")
                  .find(".tab-content.active")
                  .find(t)
                  .slick("slickPrev");
              }),
            $("[data-product-tabs]")
              .find(".nav-next")
              .click(function () {
                $(this)
                  .parents("[data-product-tabs]")
                  .find(".tab-content.active")
                  .find(t)
                  .slick("slickNext");
              })));
      });
    },
    productItemSwatch: function () {
      ($(document).on("change", ".selector-wrapper :radio", function (t) {
        var a,
          i = $(this),
          e = i.parents(".item-product"),
          o = i.parents(".product__popup-swatch"),
          n = e.data("json-product").variants,
          s = e.find(".opt-color").data("opt-position"),
          r = i.closest("[data-option-index]").data("option-index"),
          d = o.find(".swatch-element"),
          c = i.val(),
          l = o.find("[name=id]"),
          p = o.find(".selector-wrapper-1").find("input:checked").val(),
          u = o.find(".selector-wrapper-2").find("input:checked").val(),
          m = o.find(".selector-wrapper-3").find("input:checked").val();
        switch (
          (d.removeClass("soldout"), d.find(":radio").prop("disabled", !1), r)
        ) {
          case 0:
            var v = n.find(function (t) {
              return 1 == s
                ? t.option2 == c && t.option1 == u
                : 2 == s
                  ? t.option3 == c && t.option1 == u
                  : t.option1 == c && t.option2 == u;
            });
            if (void 0 != v) a = v;
            else {
              var f = n.find(function (t) {
                return 1 == s
                  ? t.option2 == c
                  : 2 == s
                    ? t.option3 == c
                    : t.option1 == c;
              });
              a = f;
            }
            break;
          case 1:
            var v = n.find(function (t) {
              return 1 == s
                ? t.option2 == p && t.option1 == c && t.option3 == m
                : 2 == s
                  ? t.option3 == p && t.option1 == c && t.option2 == m
                  : t.option1 == p && t.option2 == c && t.option3 == m;
            });
            if (void 0 != v) a = v;
            else {
              var f = n.find(function (t) {
                return 1 == s
                  ? t.option2 == p && t.option1 == c
                  : 2 == s
                    ? t.option3 == p && t.option1 == c
                    : t.option1 == p && t.option2 == c;
              });
              a = f;
            }
            break;
          case 2:
            var v = n.find(function (t) {
              return 1 == s
                ? t.option2 == p && t.option1 == u && t.option3 == c
                : 2 == s
                  ? t.option3 == p && t.option1 == u && t.option2 == c
                  : t.option1 == p && t.option2 == u && t.option3 == c;
            });
            void 0 != v && (a = v);
        }
        if (void 0 != a) {
          (l.val(a.id),
            a.compare_at_price > a.price
              ? e
                  .find("[data-compare-price-grid]")
                  .html(
                    Shopify.formatMoney(a.compare_at_price, theme.moneyFormat),
                  )
              : e.find("[data-compare-price-grid]").html(""),
            e
              .find("[data-price-grid]")
              .html(Shopify.formatMoney(a.price, theme.moneyFormat)),
            i.parents(".selector-wrapper").find(".form-label span").text(c),
            nuranium.checkStatusSwatch(e, o));
          var h = o.find(".current_variant_id").attr("value"),
            g = o
              .find('.product-form__variants [value="' + h + '"]')
              .data("inventory_policy"),
            b = o
              .find('.product-form__variants [value="' + h + '"]')
              .data("inventory_management");
          "continue" == g && "shopify" == b
            ? o
                .find("[data-btn-addtocart] .add-to-cart-text")
                .text(window.inventory_text.preorder)
            : o
                .find("[data-btn-addtocart] .add-to-cart-text")
                .text(window.inventory_text.add_to_cart);
        }
      }),
        $(document).on(
          "change",
          ".item-product__popup--variant select.single-option-selector",
          function () {
            var t,
              a = $(this),
              i = a.parents(".item-product"),
              e = a.parents(".product__popup-swatch"),
              o = i.data("json-product").variants,
              n = a.data("option"),
              s = a.val(),
              r = e.find("[name=id]"),
              d = e.find('[data-option="option1"]').val(),
              c = e.find('[data-option="option2"]').val();
            switch ((e.find('[data-option="option3"]').val(), n)) {
              case "option1":
                var l = o.find(function (t) {
                  return t.option1 == s && t.option2 == c && t.available;
                });
                t =
                  void 0 != l
                    ? l
                    : o.find(function (t) {
                        return t.option1 == s && t.available;
                      });
                break;
              case "option2":
                var l = o.find(function (t) {
                  return t.option1 == d && t.option2 == s && t.available;
                });
                void 0 != l && (t = l);
                break;
              case "option3":
                var l = o.find(function (t) {
                  return (
                    t.option1 == d &&
                    t.option2 == c &&
                    t.option3 == s &&
                    t.available
                  );
                });
                void 0 != l && (t = l);
            }
            (void 0 != t && r.val(t.id),
              a.parents(".selector-wrapper").find(".form-label span").text(s),
              nuranium.checkStatusSwatch(i, e));
            var p = e.find(".current_variant_id").attr("value"),
              u = e
                .find('.product-form__variants [value="' + p + '"]')
                .data("inventory_policy"),
              m = e
                .find('.product-form__variants [value="' + p + '"]')
                .data("inventory_management");
            ("continue" == u && "shopify" == m
              ? e
                  .find("[data-btn-addtocart] .add-to-cart-text")
                  .text(window.inventory_text.preorder)
              : e
                  .find("[data-btn-addtocart] .add-to-cart-text")
                  .text(window.inventory_text.add_to_cart),
              i
                .find("[data-price-grid]")
                .html(Shopify.formatMoney(t.price, theme.moneyFormat)));
          },
        ),
        $(document).on(
          "click",
          ".selector-wrapper .unavailable :radio",
          function (t) {
            $(this)
              .parents(".item-product")
              .find("[data-btn-addtocart]")
              .attr("disabled", "disabled");
          },
        ));
    },
    initproductItemColorSwatch: function () {
      var t = ".item-swatch li label";
      (body.off("click.toggleClass").on("click.toggleClass", t, function () {
        var t = $(this),
          a = t.attr("data-title").replace(/^\s+|\s+$/g, ""),
          i = t.closest(".item");
        (t.parents(".item-swatch").find("li label").removeClass("active"),
          t.addClass("active"));
        var e = $(this).parents(".item-product").data("json-product");
        if (
          (i.find("a").attr("href"),
          i.find(".product__label-color").find("[data-change-title]").text(a),
          void 0 != t.data("with-one-option"))
        ) {
          var o = t.data("quantity"),
            n = t.data("inventory_policy"),
            s = t.data("inventory_management");
          (i.find('[name="id"]').val(t.data("with-one-option")),
            o > 0
              ? (i
                  .find("[data-btn-addtocart]")
                  .removeClass("disabled")
                  .removeAttr("disabled"),
                "continue" == n && "shopify" == s
                  ? i
                      .find("[data-btn-addtocart] .add-to-cart-text")
                      .text(window.inventory_text.preorder)
                  : i
                      .find("[data-btn-addtocart] .add-to-cart-text")
                      .text(window.inventory_text.add_to_cart))
              : (i
                  .find("[data-btn-addtocart]")
                  .addClass("disabled")
                  .attr("disabled", "disabled"),
                i
                  .find("[data-btn-addtocart] .add-to-cart-text")
                  .text(window.inventory_text.sold_out)));
          var r = t.data("price"),
            d = t.data("compare_at_price");
          (d > r
            ? i
                .find("[data-compare-price-grid]")
                .html(Shopify.formatMoney(d, theme.moneyFormat))
            : i.find("[data-compare-price-grid]").html(""),
            i
              .find("[data-price-grid]")
              .html(Shopify.formatMoney(r, theme.moneyFormat)));
        } else
          (void 0 != e &&
            nuranium.checkStatusSwatch(t.parents(".item-product")),
            $(".template-collection").length
              ? t.parents(".product-collection").hasClass("products-list")
                ? i
                    .find('.product-details [data-value="' + a + '"] label')
                    .trigger("click")
                : i
                    .find(".product__popup-swatch:eq(0)")
                    .find('[data-value="' + a + '"] label')
                    .trigger("click")
              : i
                  .find('[data-value="' + a + '"]')
                  .find("label")
                  .trigger("click"));
        var c = t.data("img");
        if (c)
          return (
            i
              .find(
                ".thumbnail-container .product__thumbnail, .thumbnail-container .product__thumbnail-second",
              )
              .attr({ "data-srcset": c, "data-src": c, src: c, srcset: c }),
            !1
          );
      }),
        body
          .off("click.showmore")
          .on("click.showmore", ".item-swatch-more .show_more", function (t) {
            (t.preventDefault(),
              t.stopPropagation(),
              $(this).parents(".item-swatch").toggleClass("show--more"),
              $(this).parents(".item-swatch").hasClass("show--more")
                ? $(this).children().text("-")
                : $(this).children().text("+"));
          }));
    },
    checkStatusSwatch: function (t, a) {
      if (window.use_color_swatch) {
        var i = t.data("json-product"),
          e = i.variants,
          o = t.find("[data-option-index]"),
          n = t.find(".opt-color").data("opt-position");
        void 0 == a && (a = t);
        var s = a.find('[data-option-index="0"]').find("input:checked").val(),
          r = a.find('[data-option-index="1"]').find("input:checked").val();
        (a.find('[data-option-index="2"]').find("input:checked").val(),
          o.each(function () {
            var t = $(this).data("option-index"),
              a = $(this).find(".swatch-element");
            switch (t) {
              case 0:
                a.each(function () {
                  var t = $(this).data("value"),
                    a = e.find(function (a) {
                      return 1 == n
                        ? a.option2 == t && a.available
                        : 2 == n
                          ? a.option3 == t && a.available
                          : a.option1 == t && a.available;
                    }),
                    i = e.find(function (a) {
                      return 1 == n
                        ? a.option2 == t
                        : 2 == n
                          ? a.option3 == t
                          : a.option1 == t;
                    });
                  void 0 == a
                    ? void 0 == i
                      ? ($(this).addClass("unavailable"),
                        $(this).removeClass("soldout"),
                        $(this).removeClass("available"),
                        $(this).find(":radio").prop("checked", !1),
                        $(this).attr("data-toggle", "modal"),
                        $(this).attr("data-target", "#Form_newletter"))
                      : ($(this).addClass("soldout"),
                        $(this).removeClass("unavailable"),
                        $(this).removeClass("available"),
                        $(this).find(":radio").prop("disabled", !1),
                        $(this).attr("data-toggle", "modal"),
                        $(this).attr("data-target", "#Form_newletter"))
                    : ($(this).removeClass("soldout"),
                      $(this).removeClass("unavailable"),
                      $(this).addClass("available"),
                      $(this).find(":radio").prop("disabled", !1),
                      $(this).removeAttr("data-toggle", "modal"),
                      $(this).removeAttr("data-target", "#Form_newletter"));
                });
                break;
              case 1:
                a.each(function () {
                  var t = $(this).data("value"),
                    a = e.find(function (a) {
                      return 1 == n
                        ? a.option2 == s && a.option1 == t && a.available
                        : 2 == n
                          ? a.option3 == s && a.option1 == t && a.available
                          : a.option1 == s && a.option2 == t && a.available;
                    }),
                    i = e.find(function (a) {
                      return 1 == n
                        ? a.option2 == s && a.option1 == t
                        : 2 == n
                          ? a.option3 == s && a.option1 == t
                          : a.option1 == s && a.option2 == t;
                    });
                  void 0 == a
                    ? void 0 == i
                      ? ($(this).addClass("unavailable"),
                        $(this).removeClass("soldout"),
                        $(this).removeClass("available"),
                        $(this).find(":radio").prop("checked", !1),
                        $(this).attr("data-toggle", "modal"),
                        $(this).attr("data-target", "#Form_newletter"))
                      : ($(this).addClass("soldout"),
                        $(this).removeClass("unavailable"),
                        $(this).removeClass("available"),
                        $(this).find(":radio").prop("disabled", !1),
                        $(this).attr("data-toggle", "modal"),
                        $(this).attr("data-target", "#Form_newletter"))
                    : ($(this).removeClass("soldout"),
                      $(this).removeClass("unavailable"),
                      $(this).addClass("available"),
                      $(this).find(":radio").prop("disabled", !1),
                      $(this).removeAttr("data-toggle", "modal"),
                      $(this).removeAttr("data-target", "#Form_newletter"));
                });
                break;
              case 2:
                a.each(function () {
                  var t = $(this).data("value");
                  $(this).data("inventory_policy");
                  var a = e.find(function (a) {
                      return 1 == n
                        ? a.option2 == s &&
                            a.option1 == r &&
                            a.option3 == t &&
                            a.available
                        : 2 == n
                          ? a.option3 == s &&
                            a.option1 == r &&
                            a.option2 == t &&
                            a.available
                          : a.option1 == s &&
                            a.option2 == r &&
                            a.option3 == t &&
                            a.available;
                    }),
                    i = e.find(function (a) {
                      return 1 == n
                        ? a.option2 == s && a.option1 == r && a.option3 == t
                        : 2 == n
                          ? a.option3 == s && a.option1 == r && a.option2 == t
                          : a.option1 == s && a.option2 == r && a.option3 == t;
                    });
                  void 0 == a
                    ? void 0 == i
                      ? ($(this).addClass("unavailable"),
                        $(this).removeClass("soldout"),
                        $(this).removeClass("available"),
                        $(this).find(":radio").prop("checked", !1),
                        $(this).attr("data-toggle", "modal"),
                        $(this).attr("data-target", "#Form_newletter"))
                      : ($(this).addClass("soldout"),
                        $(this).removeClass("unavailable"),
                        $(this).removeClass("available"),
                        $(this).find(":radio").prop("disabled", !1),
                        $(this).attr("data-toggle", "modal"),
                        $(this).attr("data-target", "#Form_newletter"))
                    : ($(this).removeClass("soldout"),
                      $(this).removeClass("unavailable"),
                      $(this).addClass("available"),
                      $(this).find(":radio").prop("disabled", !1),
                      $(this).removeAttr("data-toggle", "modal"),
                      $(this).removeAttr("data-target", "#Form_newletter"));
                });
            }
          }),
          a.find(".swatch-element.soldout").find("input:checked").length
            ? a.find("[data-btn-addtocart]").attr("disabled", !0)
            : a.find("[data-btn-addtocart]").removeAttr("disabled"),
          a.find(".selector-wrapper:not(.opt-color)").each(function () {
            0 == $(this).find(".swatch-element").find("input:checked").length &&
              ($(this).find(".swatch-element.available").length
                ? $(this)
                    .find(".swatch-element.available")
                    .eq("0")
                    .find("label")
                    .trigger("click")
                : $(this)
                    .find(".swatch-element.soldout")
                    .eq("0")
                    .find("label")
                    .trigger("click"));
          }));
      } else {
        var i = t.data("json-product"),
          e = i.variants,
          o = t.find(".item-product__popup--variant [data-option]"),
          s = a
            .find('.item-product__popup--variant [data-option="option1"]')
            .val(),
          r = a
            .find('.item-product__popup--variant [data-option="option2"]')
            .val();
        (a.find('.item-product__popup--variant [data-option="option3"]').val(),
          o.each(function () {
            var t = $(this).data("option-index"),
              i = $(this).find("option");
            switch (t) {
              case 0:
                i.each(function () {
                  var t = $(this).val();
                  void 0 ==
                  e.find(function (a) {
                    return a.option1 == t && a.available;
                  })
                    ? void 0 ==
                      e.find(function (a) {
                        return a.option1 == t;
                      })
                      ? $(this).attr("status", "unavailable")
                      : $(this).attr("status", "soldout")
                    : $(this).attr("status", "available");
                });
                break;
              case 1:
                i.each(function () {
                  var t = $(this).val();
                  void 0 ==
                  e.find(function (a) {
                    return a.option1 == s && a.option2 == t && a.available;
                  })
                    ? void 0 ==
                      e.find(function (a) {
                        return a.option1 == s && a.option2 == t;
                      })
                      ? $(this).attr("status", "unavailable")
                      : $(this).attr("status", "soldout")
                    : $(this).attr("status", "available");
                });
                break;
              case 2:
                i.each(function () {
                  var t = $(this).val();
                  void 0 ==
                  e.find(function (a) {
                    return (
                      a.option1 == s &&
                      a.option2 == r &&
                      a.option3 == t &&
                      a.available
                    );
                  })
                    ? void 0 ==
                      e.find(function (a) {
                        return (
                          a.option1 == s && a.option2 == r && a.option3 == t
                        );
                      })
                      ? $(this).attr("status", "unavailable")
                      : $(this).attr("status", "soldout")
                    : $(this).attr("status", "available");
                });
            }
            a
              .find(".item-product__popup--variant .single-option-selector")
              .find(
                'option[status="soldout"]:selected, option[status="unavailable"]:selected',
              ).length
              ? a.find("[data-btn-addtocart]").attr("disabled", !0)
              : a.find("[data-btn-addtocart]").removeAttr("disabled");
          }));
      }
    },
    initNovWishListsPage: function () {
      "undefined" != typeof Storage
        ? !(wishListsArr.length <= 0) &&
          wishListsArr.forEach(function (t) {
            nuranium.createNovWishListTplItem(t);
          })
        : alert("Storage no support!");
    },
    initNovWishListIcons: function () {
      if (wishListsArr.length) {
        for (var t = 0; t < wishListsArr.length; t++) {
          var a = $('[data-product-handle="' + wishListsArr[t] + '"]');
          (a.addClass("whislist-added"),
            a.find(".btn-tootip").text(theme.strings.remove_wishlist));
        }
        if ("undefined" != typeof Storage) {
          if (wishListsArr.length <= 0) return;
          setTimeout(function () {
            wishListsArr.forEach(function (t) {
              nuranium.setNovAddedForWishlistIcon(t);
            });
          }, 1e3);
        } else alert("Storage no support!");
      }
    },
    setNovAddedForWishlistIcon: function (t) {
      var a = $('[data-product-handle="' + t + '"]'),
        i = theme.strings.addto_wishlist,
        e = theme.strings.remove_wishlist;
      (theme.strings.addto_favourite,
        (idxArr = wishListsArr.indexOf(t)),
        $(".WishlistCount").text(wishListsArr.length),
        idxArr >= 0
          ? (a.addClass("whislist-added"),
            a.find(".btn-tootip").text(e),
            a.attr("title", e))
          : (a.removeClass("whislist-added"),
            a.find(".btn-tootip").text(i),
            a.attr("title", i)));
    },
    doAddOrRemoveWishlist: function () {
      var t = ".item-product [data-icon-wishlist]",
        a = theme.strings.addto_wishlist,
        i = theme.strings.remove_wishlist;
      (theme.strings.addto_favourite,
        $(document)
          .off("click.addOrRemoveWishlist", t)
          .on("click.addOrRemoveWishlist", t, function (t) {
            t.preventDefault();
            var e = $(this),
              o = e.data("id"),
              n = e.data("product-handle"),
              s = wishListsArr.indexOf(n);
            if (e.hasClass("whislist-added"))
              (e.removeClass("whislist-added"),
                e.find(".btn-tootip").text(a),
                e.attr({ title: a, "data-original-title": a }),
                $(".tooltip-inner").text(a),
                $('[data-wishlist-added="wishlist-' + o + '"]').length &&
                  $('[data-wishlist-added="wishlist-' + o + '"]').remove(),
                wishListsArr.splice(s, 1),
                localStorage.setItem(
                  "wishListsArr",
                  JSON.stringify(wishListsArr),
                ));
            else {
              (e.addClass("whislist-added"),
                e.find(".btn-tootip").text(i),
                e.attr({ title: i, "data-original-title": i }),
                $(".tooltip-inner").text(i));
              var r = e.parents(".item-product").find(".product__title").html(),
                d = e
                  .parents(".item-product")
                  .find(".product__thumbnail")
                  .attr("srcset")
                  ? e
                      .parents(".item-product")
                      .find(".product__thumbnail")
                      .attr("srcset")
                  : e
                      .parents(".item-product")
                      .find(".product__thumbnail")
                      .attr("src");
              ($(".loading-modal").find(".product-title").html(r),
                $(".loading-modal").find(".product-image").attr("srcset", d),
                $(".loading-modal").find(".btn-wishlist").show(),
                $(".loading-modal").css({
                  opacity: "1",
                  visibility: "initial",
                  transform: "translateX(0)",
                  transition: "all 0.3s",
                }),
                $(".loading-modal").addClass("novload"),
                setTimeout(function () {
                  ($(".loading-modal").css({
                    opacity: "0",
                    visibility: "hidden",
                    transform: "translateX(410px)",
                    transition: "all 0.3s",
                  }),
                    $(".loading-modal").removeClass("novload"));
                }, 5e3),
                $("[data-wishlist-container]").length &&
                  nuranium.createNovWishListTplItem(n),
                wishListsArr.push(n),
                localStorage.setItem(
                  "wishListsArr",
                  JSON.stringify(wishListsArr),
                ));
            }
            nuranium.setNovAddedForWishlistIcon(n);
          }));
    },
    doAddOrRemoveWishlistProduct: function () {
      var t = ".product-single__wishlist a[data-icon-wishlist]";
      $(document)
        .off("click.addOrRemoveWishlist", t)
        .on("click.addOrRemoveWishlist", t, function (t) {
          t.preventDefault();
          var a = $(this),
            i = a.data("id"),
            e = a.data("product-handle"),
            o = wishListsArr.indexOf(e);
          if (a.hasClass("whislist-added"))
            (a.removeClass("whislist-added"),
              a.find(".btn-tootip").text(theme.strings.addto_wishlist),
              $('[data-wishlist-added="wishlist-' + i + '"]').length &&
                $('[data-wishlist-added="wishlist-' + i + '"]').remove(),
              wishListsArr.splice(o, 1),
              localStorage.setItem(
                "wishListsArr",
                JSON.stringify(wishListsArr),
              ));
          else {
            (a.addClass("whislist-added"),
              a.find(".btn-tootip").text(theme.strings.remove_wishlist));
            var n = a
                .parents(".product-single")
                .find(".product-single__title")
                .html(),
              s = a
                .parents(".product-single")
                .find(".product-single__photos .thumblist .thumbItem img")
                .attr("src")
                ? a
                    .parents(".product-single")
                    .find(".product-single__photos .thumblist .thumbItem img")
                    .attr("src")
                : a
                    .parents(".product-single")
                    .find(".product-single__photos .proFeaturedImage img")
                    .attr("src");
            ($(".loading-modal").find(".product-title").html(n),
              $(".loading-modal").find(".product-image").attr("src", s),
              $(".loading-modal").find(".btn-wishlist").show(),
              $(".loading-modal").css({
                opacity: "1",
                visibility: "initial",
                transform: "translateX(0)",
                transition: "all 0.3s",
              }),
              $(".loading-modal").addClass("novload"),
              setTimeout(function () {
                ($(".loading-modal").css({
                  opacity: "0",
                  visibility: "hidden",
                  transform: "translateX(410px)",
                  transition: "all 0.3s",
                }),
                  $(".loading-modal").removeClass("novload"));
              }, 5e3),
              $("[data-wishlist-container]").length &&
                nuranium.createNovWishListTplItem(e),
              wishListsArr.push(e),
              localStorage.setItem(
                "wishListsArr",
                JSON.stringify(wishListsArr),
              ));
          }
          nuranium.setNovAddedForWishlistIcon(e);
        });
    },
    createNovWishListTplItem: function (t) {
      var a = $("[data-wishlist-container]");
      jQuery.getJSON(window.router + "/products/" + t + ".js", function (t) {
        var i = "",
          e = Shopify.formatMoney(t.price_min, theme.moneyFormat),
          o = Shopify.formatMoney(t.compare_at_price_min, theme.moneyFormat),
          n = new Date(),
          s = r(n);
        function r(t) {
          var a = [
              "JAN",
              "FEB",
              "MAR",
              "APR",
              "MAY",
              "JUN",
              "JUL",
              "AUG",
              "SEP",
              "OCT",
              "NOV",
              "DEC",
            ][t.getMonth()],
            i = t.getDate(),
            e = t.getFullYear();
          return a + " " + d(i) + ", " + e;
        }
        function d(t) {
          return t < 10 ? "0" + t : t;
        }
        ((i +=
          '<div class="item d-sm-flex align-items-center" data-wishlist-added="wishlist-' +
          t.id +
          '">'),
          (i +=
            '<div class="item-product" data-product-id="product-' +
            t.handle +
            '">'),
          (i +=
            '<a class="whislist-added" href="#" data-product-handle="' +
            t.handle +
            '" data-icon-wishlist data-id="' +
            t.id +
            '"><i class="fa fa-trash-o"></i></a>'),
          (i += '<div class="thumbnail-container">'),
          (i += '<a href="' + t.url + '">'),
          (i +=
            '<img class="product__thumbnail" src="' +
            t.featured_image +
            '" alt="' +
            t.featured_image.alt +
            '">'),
          (i += "</a>"),
          (i += "</div>"),
          (i += '<div class="product__info">'),
          (i +=
            '<div class="product__title"><a href="' +
            t.url +
            '" title="' +
            t.title +
            '">' +
            t.title +
            "</a></div>"),
          o > e
            ? ((i += '<div class="price-sale">'),
              (i +=
                '<span class="special-price" data-price-grid>' + e + "</span>"),
              (i +=
                '<span class="old-price" data-compare-price-grid>' +
                o +
                "</span>"),
              (i += "</div>"))
            : ((i += '<div class="price-regular">'),
              (i += "<span data-price-grid>" + e + "</span>"),
              (i += "</div>")),
          (i +=
            '<div class="product__created mt-5"><i class="zmdi zmdi-calendar-note"></i>' +
            s +
            "</div>"),
          (i += "</div>"),
          (i += "</div>"),
          (i +=
            '<a class="btnProductQuickview btn mt-xs-40" href="#" data-url="/products/' +
            t.handle +
            '?view=quick_view" data-product-url="/products/' +
            t.handle +
            '"  data-handle="' +
            t.handle +
            '" data-pid="' +
            t.id +
            '">'),
          (i += "" + theme.strings.quickview),
          (i += "</a>"),
          (i += "</div>"),
          a.append(i));
      });
    },
    ajaxAddToCart: function () {
      $(document).on("click", "button.btnAddToCart", function (t) {
        var a = $(this);
        (t.preventDefault(),
          a.css("pointer-events", "none").addClass("loading"),
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: a.parents("form").serialize(),
            dataType: "json",
            success: function (t) {
              $.get("/cart?view=json", function (t) {
                $("#cart-info").html(t);
              }).always(function () {
                ("show_popup" == theme.cart_status &&
                  nuranium.initAddToCart(t.image, t.title),
                  $(".form-cart__extent").length || nuranium.initCartExtend(),
                  nuranium.updateMiniCart(),
                  nuranium.PopupAddToCart(),
                  a
                    .parents("form")
                    .find(".product-form__item-error")
                    .addClass("hidden"),
                  a.css("pointer-events", "auto").removeClass("loading"),
                  $(document).find(".quickviewClose").trigger("click"),
                  "show_minicart" == theme.cart_status &&
                    setTimeout(function () {
                      ($("#desktop_cart").addClass("active"),
                        $(".sidebar-overlay").addClass("act"));
                    }, 300));
              });
            },
            error: function (t, i) {
              (a.removeClass("loading").css("pointer-events", "auto"),
                a
                  .parents("form")
                  .find(".product-form__item-error")
                  .removeClass("hidden"));
            },
          }));
      });
    },
    initAddToCart: function (t, a) {
      $.ajax({
        url: "/cart/?view=upsell",
        dataType: "html",
        type: "GET",
        beforeSend: function () {
          $("body").addClass("cart_popup_opened");
        },
        success: function (t) {
          $.magnificPopup.open({
            items: {
              src:
                '<div class="nov-with-anim product-quickview popup-quick-view cart__popup cart__popup_upsell"><div id="content_cart__popup_nt">' +
                t +
                "</div></div>",
              type: "inline",
            },
            removalDelay: 500,
            closeMarkup: '<i class="close-icon nov-close"></i>',
            callbacks: {
              beforeOpen: function () {
                this.st.mainClass = "nov-move-horizontal";
              },
              open: function () {
                (nuranium.PopupAddToCart(),
                  (rtl = !!$("html").hasClass("lang-rtl")),
                  $(".product-related-slider").slick({
                    nextArrow:
                      '<div class="arrow-next"><i class="zmdi zmdi-chevron-right"></i></div>',
                    prevArrow:
                      '<div class="arrow-prev"><i class="zmdi zmdi-chevron-left"></i></div>',
                    rtl: rtl,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    arrows: !1,
                    dots: !0,
                    infinite: !0,
                    responsive: [
                      {
                        breakpoint: 992,
                        settings: { slidesToShow: 2, slidesToScroll: 2 },
                      },
                      {
                        breakpoint: 768,
                        settings: { slidesToShow: 1, slidesToScroll: 1 },
                      },
                    ],
                  }));
              },
              change: function () {},
              close: function () {
                $("body").hasClass("template-cart")
                  ? window.location.reload()
                  : ($("body").removeClass("cart_popup_opened"),
                    $("body").removeClass("loading"),
                    $("#content_cart__popup_nt").empty());
              },
            },
          });
        },
        complete: function () {
          if ((nuranium.PopupAddToCart(), $(".loader").remove(), a)) {
            var t =
              '<div class="cart-message"><i class="zmdi zmdi-notifications-active"></i><strong>' +
              a +
              "</strong> - " +
              theme.strings.cart_message_html +
              "</div>";
            ($(".cart-popup-heading").after(t),
              setTimeout(function () {
                $(".cart-message").slideUp();
              }, 4e3));
          }
        },
        error: function () {
          $(".loader").remove();
        },
      });
    },
    updateMiniCart: function () {
      Shopify.getCart(function (t) {
        nuranium.doUpdateMiniCart(t);
      });
    },
    doUpdateMiniCart: function (t) {
      ($(".CartCount, #CartCountCavas").text(t.item_count),
        $(".cart-popup-heading span").html(
          "There are " + t.item_count + " item(s) in your cart",
        ));
    },
    ajaxChangeFromCart: function () {
      $(document).on(
        "change",
        ".cart__popup-qty--input, .cart__mini-qty--input",
        function (t) {
          t.preventDefault();
        },
      );
    },
    PopupAddToCart: function () {
      function t(t, a) {
        ($(".cart__popup").addClass("loading"),
          $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: "quantity=" + a + "&id=" + t,
            dataType: "json",
            success: function (i) {
              (jQuery
                .get("/cart?view=up_ajax", function (i) {
                  i = jQuery(i);
                  var e = jQuery(i),
                    o = jQuery(e.get(0)).html(),
                    n = jQuery(e.get(2)).html(),
                    s = $(".cart__popup #" + t).find(
                      ".cart__popup-total .amount",
                    );
                  $(".cart__popup #" + t)
                    .find(".cart__popup-qty--input")
                    .val(a);
                  var r = parseFloat(s.data("price")) * a;
                  (s.html(Shopify.formatMoney(r, theme.moneyFormat)),
                    $("#cart__popup_total").html(o),
                    $("#threshold_bar_popup").html(n));
                })
                .always(function () {
                  $(".cart__popup").removeClass("loading");
                }),
                $.get("/cart?view=json", function (t) {
                  $("#cart-info").html(t);
                }).always(function () {
                  nuranium.updateMiniCart();
                }));
            },
            error: function (t, a) {
              $(".cart__popup").removeClass("loading");
            },
          }));
      }
      $(document).on("click", ".cart__popup-qty", function (a) {
        a.preventDefault();
        var i = $(this),
          e = i.siblings(".cart__popup-qty--input"),
          o = e.attr("data-id"),
          n = parseFloat(e.val()),
          s = parseFloat(e.attr("step")),
          r = parseFloat(e.attr("min")),
          d = parseFloat(e.attr("max"));
        if (i.hasClass("cart__popup-qty--plus")) {
          var c = n + s;
          if (c > d && d > 0) {
            e.val(d);
            return;
          }
        } else if (i.hasClass("cart__popup-qty--minus")) {
          var c = n - s;
          if (0 === c) {
            var l = parseInt(e.attr("value"));
            (e.val(l),
              i
                .parents(".cart__popup-item")
                .find(".cart__popup-remove")
                .trigger("click"));
            return;
          }
          if (c < r) return;
          if (n < 0) {
            alert("Invalid");
            return;
          }
        }
        t(o, c);
      });
      var a = !0;
      $(document).on("click", ".cart__popup-remove", function (t) {
        t.preventDefault();
        var i = $(this),
          e = i
            .siblings(".cart__popup-quantity")
            .find(".cart__popup-qty--input"),
          o = i.find("a").attr("data-product-id"),
          n = parseInt(e.val());
        (($ptitle = i
          .parent(".cart__popup-item")
          .find(".cart__popup-title a")
          .text()),
          $(".cart__popup .cart-message").slideDown(),
          a &&
            (setTimeout(function () {
              $(".cart__popup .cart-message").slideUp();
            }, 4e3),
            (a = !1),
            setTimeout(function () {
              a = !0;
            }, 4e3)),
          $(".cart__popup").addClass("loading"),
          $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: "quantity=0&id=" + o,
            dataType: "json",
            success: function (t) {
              (jQuery
                .get("/cart?view=up_ajax", function (t) {})
                .always(function (t) {
                  t = jQuery(t);
                  var a = jQuery(t),
                    e = jQuery(a.get(0)).html(),
                    s = jQuery(a.get(2)).html();
                  ($("#cart__popup_total").html(e),
                    $("#threshold_bar_popup").html(s),
                    $(".cart__popup #" + o).addClass("hide"),
                    n > 0
                      ? $("#" + o + " input").val(n)
                      : $(".cart__popup #" + o + " input").val(1),
                    $(".cart__popup .cart-message").html(
                      '<i class="rbb-icon-delete-outline-2"></i> <strong>' +
                        $ptitle +
                        "</strong> - has been removed into your shopping cart.",
                    ),
                    $(".cart__popup .cart-message")
                      .removeClass("removed")
                      .addClass("removed"),
                    $(".cart__popup").removeClass("loading"),
                    i.parents(".cart__popup-item").remove());
                }),
                $.get("/cart?view=json", function (t) {
                  $("#cart-info").html(t);
                }).always(function () {
                  nuranium.updateMiniCart();
                }));
            },
          }));
      });
    },
  initMiniCart: function () {
  $.get("/cart?view=extend", function (cartExtendHtml) {
    var cartExtend = $(cartExtendHtml),
      cartNoteHtml = cartExtend.find('[data-label="note"]').html(),
      estimateShippingHtml = cartExtend.find('[data-label="estimate-shipping"]').html(),
      discountHtml = cartExtend.find('[data-label="discount"]').html();

    jQuery.getJSON("/cart.js", function (cart) {
      $(".CartCount, #CartCountCavas").text(cart.item_count);
      $("#cart-info").html("");
      $("#desktop_cart").addClass("item_count");

      if (cart.item_count > 0) {
        var html = "";

        html += '<form action="/cart" method="post" class="cart ajaxcart">';
        html += '<input class="js-form-discount" type="hidden" name="discount" value="">';
        html += '<div class="ajaxcart__inner">';
        html += '<div class="ajaxcart__inner--content">';

        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];

          var itemImage = item.image ? Shopify.resizeImage(item.image, "220x") : "";
          var itemTitle = item.title || "";
          var itemProductTitle = item.product_title || "";
          var itemVariantTitle = item.variant_title || "";

          var itemOriginalLinePrice = Shopify.formatMoney(item.original_line_price, theme.moneyFormat);
          var itemFinalLinePrice = Shopify.formatMoney(item.final_line_price, theme.moneyFormat);
          var hasLineDiscount = item.original_line_price > item.final_line_price;

          html += '<div class="ajaxcart__product" data-line="' + i + '">';
          html += '<div class="media">';

          html += '<a href="' + item.url + '" class="position-relative">';
          html += '<img class="d-flex product-image" src="' + itemImage + '" alt="' + itemTitle + '" title="' + itemTitle + '">';
          html += "</a>";

          html += '<div class="media-body">';

          html += '<a class="product-name" href="' + item.url + '">';
          html += '<span class="title">' + itemProductTitle + "</span>";

          if (itemVariantTitle) {
            html += '<span class="bt_s">' + itemVariantTitle + "</span>";
          }

          html += "</a>";

          html += '<div class="mb-5"></div>';

          html += '<div class="ajaxcart__item-price">';

          if (hasLineDiscount) {
            html += '<span class="ajaxcart__item-price--compare money">';
            html += itemOriginalLinePrice;
            html += "</span>";

            html += '<span class="ajaxcart__item-price--final money">';
            html += itemFinalLinePrice;
            html += "</span>";
          } else {
            html += '<span class="ajaxcart__item-price--regular money">';
            html += itemFinalLinePrice;
            html += "</span>";
          }

          html += "</div>";

          if (item.line_level_discount_allocations && item.line_level_discount_allocations.length > 0) {
            html += '<div class="ajaxcart__item-discounts">';

            for (var discountIndex = 0; discountIndex < item.line_level_discount_allocations.length; discountIndex++) {
              var discountAllocation = item.line_level_discount_allocations[discountIndex];
              var discountTitle = "";

              if (
                discountAllocation.discount_application &&
                discountAllocation.discount_application.title
              ) {
                discountTitle = discountAllocation.discount_application.title;
              } else {
                discountTitle = "Discount";
              }

              html += '<div class="ajaxcart__item-discount">';
              html += '<span class="ajaxcart__item-discount-title">';
              html += discountTitle;
              html += "</span>";

              
              html += "</div>";
            }

            html += "</div>";
          }

          html += '<div class="cart__item-bottom d-flex align-items-center mt-10">';

          html += '<div class="cart__mini--qty d-flex align-items-center">';
          html += '<a class="cart__mini-qty cart__mini-qty--minus" href="#">-</a>';

          html +=
            '<input class="cart__mini-qty--input" type="number" name="updates[]" id="updates_' +
            item.key +
            '" data-price="' +
            item.final_price +
            '" data-id="' +
            item.id +
            '" data-line="' +
            i +
            '" step="1" value="' +
            item.quantity +
            '" min="1" max="" pattern="[0-9]*" />';

          html += '<a class="cart__mini-qty cart__mini-qty--plus" href="#">+</a>';
          html += "</div>";

          html +=
            '<span class="remove-from-cart" rel="nofollow" href="#" title="remove from cart" data-line="' +
            i +
            '" data-product-id="' +
            item.id +
            '">';
          html += '<i class="rbb-icon-delete-outline-2"></i>';
          html += "</span>";

          html += "</div>";
          html += "</div>";
          html += "</div>";
          html += "</div>";
        }

        html += "</div>";
        html += "</div>";

        html += '<div class="ajaxcart__footer">';

        html += '<div class="ajaxcart__summary">';

        html += '<div class="subtotal d-flex align-items-center justify-content-between">';
        html += "<label>Subtotal:</label>";
        html += "<span>" + Shopify.formatMoney(cart.original_total_price, theme.moneyFormat) + "</span>";
        html += "</div>";

        html += '<div class="discount-total d-flex align-items-center justify-content-between">';
        html += "<label>Discount:</label>";

        if (cart.total_discount > 0) {
          html += "<span>- " + Shopify.formatMoney(cart.total_discount, theme.moneyFormat) + "</span>";
        } else {
          html += "<span>" + Shopify.formatMoney(0, theme.moneyFormat) + "</span>";
        }

        html += "</div>";

        html += '<div class="cart-total d-flex align-items-center justify-content-between">';
        html += "<label>Total:</label>";
        html += "<span>" + Shopify.formatMoney(cart.total_price, theme.moneyFormat) + "</span>";
        html += "</div>";

        html += "</div>";

        html += '<div class="cart_extend--label row spacing-0 d-md-none mb-15">';

        if (theme.cart_note === true) {
          html += '<div class="extend--label__item col" data-label="note">';
          html += cartNoteHtml || "";
          html += "</div>";
        }

        if (theme.cart_shipping_calculator === true) {
          html += '<div class="extend--label__item col" data-label="estimate-shipping">';
          html += estimateShippingHtml || "";
          html += "</div>";
        }

        if (theme.cart_discount_code === true) {
          html += '<div class="extend--label__item col" data-label="discount">';
          html += discountHtml || "";
          html += "</div>";
        }

        html += "</div>";

        var cartTotal = cart.total_price;
        var freeShippingValue = theme.freeshipping_value;

        if (theme.show_free_shipping === true) {
          if (parseFloat(cartTotal / 100) < parseFloat(freeShippingValue)) {
            var remainingAmount = (parseFloat(freeShippingValue) - parseFloat(cartTotal / 100)).toFixed(0);
            var progressWidth = Math.min(
              (parseFloat(cartTotal / 100) / parseFloat(freeShippingValue)) * 100,
              100
            );

            html += '<div id="threshold_bar_popup_minicart">';
            html += '<div class="cart_threshold">';

            html += '<div class="threshold_spend">';
            html +=
              theme.strings.spend +
              " " +
              Shopify.formatMoney(100 * remainingAmount, theme.moneyFormat) +
              " " +
              theme.strings.spend__html;
            html += "</div>";

            html += '<div class="threshold_bar">';
            html += '<span class="animate" style="width:' + progressWidth + '% !important">';
            html += '<span><i class="rbb-icon-delivery-11"></i></span>';
            html += "</span>";
            html += "</div>";

            html += "</div>";
            html += "</div>";
          } else {
            html += '<div id="threshold_bar_popup_minicart">';

            html += '<div class="threshold_spend spend_congrats">';
            html += "<span>" + theme.strings.content_threshold + '<i class="rbb-icon-delivery-11"></i></span>';
            html += "</div>";

            html += '<div class="threshold_bar threshold_congrats">';
            html += '<span class="animate" style="width: 100% !important;">';
            html += '<span><i class="rbb-icon-delivery-11"></i></span>';
            html += "</span>";
            html += "</div>";

            html += "</div>";
          }
        }

        html += '<div class="btn_submit">';

        if (theme.terms_conditions_enable === true) {
          html += '<input type="checkbox" name="checkout__input" value="1" id="checkout__canvas" class="hide">';
        }

        html += '<a href="/cart" class="btn btn-success">';
        html += "<span>" + theme.strings.view_cart + "</span>";
        html += "</a>";

        html += '<button type="submit" class="btn cart__checkout" name="checkout">';
        html += "<span>" + theme.strings.check_out + "</span>";
        html += "</button>";

        if (theme.terms_conditions_enable === true) {
          html += '<label for="checkout__canvas" class="d-flex align-items-center mt-20">';
          html += '<span class="custom-checkbox pointer d-inline-flex align-items-center justify-content-center">';
          html += '<i class="zmdi zmdi-check"></i>';
          html += "</span>";
          html += '<span class="label__text">' + theme.proceed_to_checkout + "</span>";
          html += "</label>";
        }

        html += "</div>";
        html += "</div>";
        html += "</form>";

        $("#cart-info").append(html);

        var ajaxCartInnerHeight = $(".ajaxcart__inner").outerHeight();
        var ajaxCartFooterHeight = $(".ajaxcart__footer").outerHeight();
        var ajaxCartHeight = $(".ajaxcart").height() - 30;

        if (ajaxCartInnerHeight + ajaxCartFooterHeight >= ajaxCartHeight) {
          $(".ajaxcart__footer").addClass("h_scroll");
        }

        if (!$(".form-cart__extent").length) {
          nuranium.initCartExtend();
        }
      } else {
        var emptyCartCollectionLink = $(".link_to_collection_cart_empty").html();
        var emptyHtml = "";

        emptyHtml += '<div class="cart cart_empty">';
        emptyHtml += '<div class="cart_empty_img"></div>';
        emptyHtml += '<div class="empty_title text-center">' + theme.strings.cart_empty + "</div>";
        emptyHtml += '<div class="text-center mt-40 block_link_cart">';
        emptyHtml += emptyCartCollectionLink || "";
        emptyHtml += "</div>";
        emptyHtml += "</div>";

        $("#cart-info").append(emptyHtml);
        $("#desktop_cart").removeClass("item_count");
        $(".form-cart__extent").remove();
      }
    });
  });
},
    ajaxProductAddToCart: function () {
      $(document).on("click", ".product-form__cart-submit", function (t) {
        t.preventDefault();
        var a = $(this);
        (a.css("pointer-events", "none").addClass("loading"),
          $(".lookbook-modal").modal("hide"),
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: a.parents("form").serialize(),
            dataType: "json",
            success: function (t) {
              $.get("/cart?view=json", function (t) {
                $("#cart-info").html(t);
              }).always(function () {
                ("show_popup" == theme.cart_status &&
                  nuranium.initAddToCart(t.image, t.title),
                  $(".form-cart__extent").length || nuranium.initCartExtend(),
                  nuranium.updateMiniCart(),
                  nuranium.PopupAddToCart(),
                  a.css("pointer-events", "auto").removeClass("loading"),
                  $(".cart_extend").removeClass("act"),
                  $(".cart_extend--label").removeClass("act"));
              });
            },
            complete: function () {
              ($(".product-form__cart-submit").parents(".cart_popup_opened")
                .length || $("body").removeClass("cart_popup_opened"),
                $("body").removeClass("loading"),
                $(".nov-close, .cart_popup_opened .nov-ready").on(
                  "click",
                  function () {
                    $("body").hasClass("template-cart") &&
                      window.location.reload();
                  },
                ),
                "show_minicart" == theme.cart_status &&
                  setTimeout(function () {
                    ($("#desktop_cart").addClass("active"),
                      $(".sidebar-overlay").addClass("act"));
                  }, 1e3),
                $(document).find(".nov-close").trigger("click"));
            },
            error: function (t, i) {
              a.removeClass("loading")
                .css("pointer-events", "auto")
                .find(".add-to-cart-text")
                .text(window.inventory_text.sold_out);
            },
          }).done(function () {
            $("body").removeClass("loading");
          }));
      });
    },
    initQuickView: function () {
      $(document).on("click", ".btnProductQuickview", function (t) {
        (t.preventDefault(), $(".lookbook-modal").modal("hide"));
        var a = $(this);
        $.ajax({
          beforeSend: function () {
            $("body").addClass("open_gl_quick_view");
          },
          url: a.attr("data-url"),
          success: function (t) {
            $.magnificPopup.open({
              items: {
                src:
                  '<div class="nov-with-anim popup-quick-view" id="content_quickview">' +
                  t +
                  "</div>",
                type: "inline",
              },
              removalDelay: 500,
              closeMarkup: '<i class="nov-close close-icon"></i>',
              callbacks: {
                beforeOpen: function () {
                  this.st.mainClass = "nov-move-horizontal";
                },
                open: function () {
                  rtl = !!$("html").hasClass("lang-rtl");
                  var t = $(".popup-quick-view").find(".FeaturedImage_slick");
                  (t.slick({
                    nextArrow:
                      '<div class="arrow-next"><i class="zmdi zmdi-chevron-right"></i></div>',
                    prevArrow:
                      '<div class="arrow-prev"><i class="zmdi zmdi-chevron-left"></i></div>',
                    rtl: rtl,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: !0,
                    dots: !1,
                    infinite: !0,
                  }),
                    $("product-variant-swatch label").click(function () {
                      setTimeout(function () {
                        var a = t.find(".item.act").attr("data-slick-index");
                        t.slick("slickGoTo", a);
                      }, 300);
                    }),
                    Shopify.PaymentButton.init(),
                    nuranium.initNovWishListIcons(),
                    jQuery("product-variant-swatch :radio").change(function () {
                      jQuery(this).closest(".swatch").attr("data-option-index");
                      var t = jQuery(this).val();
                      jQuery(this)
                        .parents("fieldset")
                        .find(".variant_current")
                        .text(t);
                    }),
                    $(document).on(
                      "click",
                      "#content_quickview .product-form__item--submit",
                      function () {
                        $("#content_quickview .nov-close").trigger("click");
                      },
                    ));
                },
                close: function () {
                  ($("#content_quickview").empty(),
                    $("body").removeClass("open_gl_quick_view"),
                    $("body").removeClass("cart_popup_opened"),
                    $("body").find(".tooltip").remove());
                },
              },
            });
          },
          complete: function () {
            Shopify.PaymentButton.init();
          },
        }).done(function () {
          (a.removeClass("btn-loading"),
            $("body").removeClass("loading"),
            $("body").find(".tooltip").remove());
        });
        let i = this.getAttribute("data-product-url");
        fetch(i)
          .then((t) => t.text())
          .then((t) => {
            let a = new DOMParser().parseFromString(t, "text/html"),
              i = a
                .querySelector(".product-template__container")
                .getAttribute("data-section-id"),
              e = document.getElementById("content_quickview");
            ((e.querySelector(".product-template__container").id =
              "ProductSection-" + i),
              null !==
                e.querySelector(
                  "product-variant-swatch, product-variant-dropdown",
                ) &&
                e
                  .querySelector(
                    "product-variant-swatch, product-variant-dropdown",
                  )
                  .setAttribute("data-product-id", i),
              (e.querySelector("#ProductPrice-templateQV").id =
                "ProductPrice-" + i),
              e.querySelector("#ComparePrice-templateQV") &&
                (e.querySelector("#ComparePrice-templateQV").id =
                  "ComparePrice-" + i),
              (e.querySelector("form").id = "product-form-" + i),
              (item = e.querySelectorAll(".FeaturedImage_slick .item")));
            for (var o = 0; o < item.length; o++)
              ((mediaId = item[o].getAttribute("data-media-id")),
                item[o].setAttribute("data-media-id", i + mediaId));
            input = e.querySelectorAll("input[type=radio]");
            for (var o = 0; o < input.length; o++)
              input[o].setAttribute("form", "product-form-" + i);
          });
      });
    },
    ajaxRemoveFromCart: function () {
      $("#cart-info").on("click", ".remove-from-cart", function (t) {
        t.preventDefault();
        var a = $(this).attr("data-product-id");
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: "quantity=0&id=" + a,
          dataType: "json",
          success: function (t) {
            $("body").hasClass("template-cart")
              ? window.location.reload()
              : nuranium.initMiniCart();
          },
        });
      });
    },
    changeQuantityMiniCart: function () {
      function t(t, a) {
        $.ajax({
          type: "POST",
          url: "/cart/change.js",
          data: "quantity=" + a + "&id=" + t,
          dataType: "json",
          success: function (t) {
            (jQuery
              .get("/cart?view=up_ajax", function (t) {
                t = jQuery(t);
                var a = jQuery(t),
                  i = jQuery(a.get(0)).html(),
                  e = jQuery(a.get(2)).html();
                ((t_total = $("#cart-info").find(".subtotal")),
                  $("#cart-info").find(".subtotal span").html(i),
                  $("#threshold_bar_popup_minicart .cart_threshold").html(e));
              })
              .always(function () {}),
              $.get("/cart?view=json", function (t) {
                $("#cart-info").html(t);
              }).always(function () {
                nuranium.updateMiniCart();
              }));
          },
        });
      }
      ($(document).on("click", ".cart__mini-qty", function (a) {
        a.preventDefault();
        var i = $(this),
          e = i.siblings(".cart__mini-qty--input"),
          o = e.attr("data-id"),
          n = parseFloat(e.val()),
          s = parseFloat(e.attr("step")),
          r = parseFloat(e.attr("min")),
          d = parseFloat(e.attr("max"));
        if (i.hasClass("cart__mini-qty--plus")) {
          var c = n + s;
          if (c > d && d > 0) {
            e.val(d);
            return;
          }
          e.val(c);
        } else if (i.hasClass("cart__mini-qty--minus")) {
          var c = n - s;
          if (0 === c) {
            var l = parseInt(e.attr("value"));
            (e.val(l),
              i
                .parents(".ajaxcart__product")
                .find(".remove-from-cart")
                .trigger("click"));
            return;
          }
          if (c < r) return;
          if (n < 0) {
            alert("Invalid");
            return;
          } else e.val(c);
        }
        t(o, c);
      }),
        $(document).on("change", ".cart__mini-qty--input", function (a) {
          var i = $(this),
            e = parseFloat(i.val()),
            o = i.attr("data-id"),
            n = (parseFloat(i.attr("min")), parseFloat(i.attr("max")));
          if (e > n && n > 0) {
            e.val(n);
            return;
          }
          if (0 === e) {
            i.parents(".ajaxcart__product")
              .find(".remove-from-cart")
              .trigger("click");
            return;
          }
          t(o, e);
        }));
    },
    changeQuantityPageCart: function () {
      function t(t, a, i) {
        var e = {
          type: "POST",
          url: "/cart/change.js",
          data: "quantity=" + a + "&line=" + t,
          dataType: "json",
          success: function (t) {
            "function" == typeof i && i(t);
          },
          error: function (t, a) {},
        };
        jQuery.ajax(e);
      }
      ($(document).on(
        "change keyup",
        ".cart__qty-input, .cart__popup-qty--input",
        function () {
          var a = $(this),
            i = a.data("line"),
            e = parseInt(a.val()),
            o = a.data("price"),
            n = a.attr("max");
          if (isNaN(e)) return 0;
          ((n = isNaN(parseInt(n)) ? 9999 : parseInt(n)),
            e > n && a.attr("value", n).val(n),
            (e = e > n ? n : e) <= 0 && a.closest("tr").remove(),
            t(i, e, function (t) {
              ($(".cart__subtotal").html(
                Shopify.formatMoney(t.total_price, theme.moneyFormat),
              ),
                a
                  .parents(".cart_item")
                  .find(".product-subtotal")
                  .html(Shopify.formatMoney(o * e, theme.moneyFormat)),
                $(".CartCount, #CartCountCavas").html(t.item_count),
                $(".cart__heading span").html(
                  "There are " + t.item_count + " items in your cart",
                ),
                jQuery.get("/cart?view=ship", function (t) {
                  ($("#threshold_bar_popup").html(t),
                    setTimeout(function () {}, 200));
                }),
                $.get("/cart?view=json", function (t) {
                  $("#cart-info").html(t);
                }).always(function () {
                  nuranium.updateMiniCart();
                }));
            }));
        },
      ),
        $(document).on("click", ".plus, .minus", function () {
          var t = $(this).closest(".cart__qty").find(".cart__qty-input"),
            a = parseFloat(t.val()),
            i = parseFloat(t.attr("max")),
            e = parseFloat(t.attr("min")),
            o = t.attr("step");
          ((a && "" !== a && "NaN" !== a) || (a = 0),
            ("" === i || "NaN" === i) && (i = ""),
            ("" === e || "NaN" === e) && (e = 0),
            ("any" === o ||
              "" === o ||
              void 0 === o ||
              "NaN" === parseFloat(o)) &&
              (o = 1),
            $(this).is(".plus")
              ? i && a >= i
                ? t.val(i)
                : t.val(a + parseFloat(o))
              : e && a <= e
                ? t.val(e)
                : a > 0 && t.val(a - parseFloat(o)),
            t.trigger("change"));
        }),
        $(document).on(
          "click",
          ".quick_view-qty-plus, .quick_view-qty-minus",
          function () {
            var t = $(this)
                .closest(".quick_view_qty")
                .find('input[name="quantity"]'),
              a = parseFloat(t.val()),
              i = parseFloat(t.attr("max")),
              e = parseFloat(t.attr("min")),
              o = t.attr("step");
            ((a && "" !== a && "NaN" !== a) || (a = 0),
              ("" === i || "NaN" === i) && (i = ""),
              ("" === e || "NaN" === e) && (e = 0),
              ("any" === o ||
                "" === o ||
                void 0 === o ||
                "NaN" === parseFloat(o)) &&
                (o = 1),
              $(this).is(".quick_view-qty-plus")
                ? i && a >= i
                  ? t.val(i)
                  : t.val(a + parseFloat(o))
                : e && a <= e
                  ? t.val(e)
                  : a > 0 && t.val(a - parseFloat(o)));
          },
        ));
    },
    initCartExtend: function () {
      (jQuery.get("/cart?view=extend", function (t) {
        ($(".block_cart_top").before(t),
          $("html").hasClass("lang-rtl")
            ? $(".extend--label__item").attr("data-placement", "right")
            : $(".extend--label__item").attr("data-placement", "left"));
      }),
        setTimeout(function () {
          if ($("#shipping-calculator").length > 0) {
            var _config,
              _render,
              _enableButtons,
              _disableButtons,
              _getCartShippingRatesForDestination,
              _pollForCartShippingRatesForDestination,
              _fullMessagesFromErrors,
              _onError,
              _onCartShippingRatesUpdate,
              _formatRate;
            ("object" == typeof Countries &&
              (Countries.updateProvinceLabel = function (t, a) {
                if (
                  "string" == typeof t &&
                  Countries[t] &&
                  Countries[t].provinces &&
                  ("object" == typeof a ||
                    null !==
                      (a = document.getElementById("address_province_label")))
                ) {
                  a.innerHTML = Countries[t].label;
                  var i = jQuery(a).parent();
                  (i.find("select"),
                    i
                      .find(".custom-style-select-box-inner")
                      .html(Countries[t].provinces[0]));
                }
              }),
              void 0 === Shopify.Cart && (Shopify.Cart = {}),
              (Shopify.Cart.ShippingCalculator =
                ((_config = {
                  submitButton: "Calculate shipping",
                  submitButtonDisabled: "Calculating...",
                  templateId: "shipping-calculator-response-template",
                  wrapperId: "wrapper-response",
                  customerIsLoggedIn: !1,
                  moneyFormat: "${{amount}}",
                }),
                (_render = function (t) {
                  var a = jQuery("#" + _config.templateId),
                    i = jQuery("#" + _config.wrapperId);
                  if (a.length && i.length) {
                    var e = Handlebars.compile(jQuery.trim(a.text()))(t);
                    if (
                      (jQuery(e).appendTo(i),
                      "undefined" != typeof Currency &&
                        "function" == typeof Currency.convertAll)
                    ) {
                      var o = "";
                      (jQuery("[name=currencies]").length > 0
                        ? (o = jQuery("[name=currencies]").val())
                        : jQuery("#currencies span.selected").length > 0 &&
                          (o = jQuery("#currencies span.selected").attr(
                            "data-currency",
                          )),
                        "" !== o &&
                          Currency.convertAll(
                            shopCurrency,
                            o,
                            "#wrapper-response span.money, #estimated-shipping span.money",
                          ));
                    }
                  }
                }),
                (_enableButtons = function () {
                  jQuery(".get-rates")
                    .removeAttr("disabled")
                    .removeClass("disabled")
                    .val(_config.submitButton);
                }),
                (_disableButtons = function () {
                  jQuery(".get-rates")
                    .val(_config.submitButtonDisabled)
                    .attr("disabled", "disabled")
                    .addClass("disabled");
                }),
                (_getCartShippingRatesForDestination = function (t) {
                  var a = {
                    type: "POST",
                    url: "/cart/prepare_shipping_rates",
                    data: jQuery.param({ shipping_address: t }),
                    success: _pollForCartShippingRatesForDestination(t),
                    error: _onError,
                  };
                  jQuery.ajax(a);
                }),
                (_pollForCartShippingRatesForDestination = function (t) {
                  var a = function () {
                    jQuery.ajax("/cart/async_shipping_rates", {
                      dataType: "json",
                      success: function (i, e, o) {
                        200 === o.status
                          ? _onCartShippingRatesUpdate(i.shipping_rates, t)
                          : setTimeout(a, 500);
                      },
                      error: _onError,
                    });
                  };
                  return a;
                }),
                (_fullMessagesFromErrors = function (t) {
                  var a = [];
                  return (
                    jQuery.each(t, function (t, i) {
                      jQuery.each(i, function (i, e) {
                        a.push(t + " " + e);
                      });
                    }),
                    a
                  );
                }),
                (_onError = function (XMLHttpRequest, textStatus) {
                  (jQuery("#estimated-shipping").hide(),
                    jQuery("#estimated-shipping em").empty(),
                    _enableButtons());
                  var feedback = "",
                    data = eval("(" + XMLHttpRequest.responseText + ")");
                  ("Error : country is not supported." ==
                    (feedback = data.message
                      ? data.message +
                        "(" +
                        data.status +
                        "): " +
                        data.description
                      : "Error : " +
                        _fullMessagesFromErrors(data).join("; ") +
                        ".") &&
                    (feedback = "We do not ship to this destination."),
                    _render({
                      rates: [],
                      errorFeedback: feedback,
                      success: !1,
                    }),
                    jQuery("#" + _config.wrapperId).show());
                }),
                (_onCartShippingRatesUpdate = function (t, a) {
                  _enableButtons();
                  var i = "";
                  if (
                    (a.zip && (i += a.zip + ", "),
                    a.province && (i += a.province + ", "),
                    (i += a.country),
                    t.length)
                  ) {
                    "0.00" == t[0].price
                      ? jQuery("#estimated-shipping em").html("FREE")
                      : jQuery("#estimated-shipping em").html(
                          _formatRate(t[0].price),
                        );
                    for (var e = 0; e < t.length; e++)
                      t[e].price = _formatRate(t[e].price);
                  }
                  (_render({ rates: t, address: i, success: !0 }),
                    jQuery(
                      "#" + _config.wrapperId + ", #estimated-shipping",
                    ).fadeIn());
                }),
                (_formatRate = function (t) {
                  function a(t, a) {
                    return void 0 === t ? a : t;
                  }
                  function i(t, i, e, o) {
                    if (
                      ((i = a(i, 2)),
                      (e = a(e, ",")),
                      (o = a(o, ".")),
                      isNaN(t) || null == t)
                    )
                      return 0;
                    var n,
                      s = (t = (t / 100).toFixed(i)).split(".");
                    return (
                      s[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + e) +
                      (s[1] ? o + s[1] : "")
                    );
                  }
                  if ("function" == typeof Shopify.formatMoney)
                    return Shopify.formatMoney(t, _config.moneyFormat);
                  "string" == typeof t && (t = t.replace(".", ""));
                  var e = "",
                    o = /\{\{\s*(\w+)\s*\}\}/,
                    n = _config.moneyFormat;
                  switch (n.match(o)[1]) {
                    case "amount":
                      e = i(t, 2);
                      break;
                    case "amount_no_decimals":
                      e = i(t, 0);
                      break;
                    case "amount_with_comma_separator":
                      e = i(t, 2, ".", ",");
                      break;
                    case "amount_no_decimals_with_comma_separator":
                      e = i(t, 0, ".", ",");
                  }
                  return n.replace(o, e);
                }),
                (_init = function () {
                  new Shopify.CountryProvinceSelector(
                    "address_country",
                    "address_province",
                    { hideElement: "address_province_container" },
                  );
                  var t = jQuery("#address_country"),
                    a = jQuery("#address_province_label").get(0);
                  ("undefined" != typeof Countries &&
                    (Countries.updateProvinceLabel(t.val(), a),
                    t.change(function () {
                      Countries.updateProvinceLabel(t.val(), a);
                    })),
                    jQuery(".get-rates").click(function () {
                      (_disableButtons(),
                        jQuery("#" + _config.wrapperId)
                          .empty()
                          .hide());
                      var t = {};
                      ((t.zip = jQuery("#address_zip").val() || ""),
                        (t.country = jQuery("#address_country").val() || ""),
                        (t.province = jQuery("#address_province").val() || ""),
                        _getCartShippingRatesForDestination(t));
                    }),
                    _config.customerIsLoggedIn &&
                      jQuery(".get-rates:eq(0)").trigger("click"));
                }),
                {
                  show: function (t) {
                    ((t = t || {}),
                      jQuery.extend(_config, t),
                      jQuery(function () {
                        _init();
                      }));
                  },
                  getConfig: function () {
                    return _config;
                  },
                  formatRate: function (t) {
                    return _formatRate(t);
                  },
                })),
              Shopify.Cart.ShippingCalculator.show({
                submitButton: theme.strings.shippingCalcSubmitButton,
                submitButtonDisabled:
                  theme.strings.shippingCalcSubmitButtonDisabled,
                customerIsLoggedIn:
                  theme.strings.shippingCalcCustomerIsLoggedIn,
                moneyFormat: theme.strings.shippingCalcMoneyFormat,
              }));
          }
        }, 1e3));
    },
  };
})(jQuery);
